// Vuetify
import { createVuetify } from 'vuetify'
// Styles
import 'vuetify/styles'

import '@mdi/font/css/materialdesignicons.css'

export default createVuetify({
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          footer: '#f0f0f0',
          black: '#000000',
          primary: '#3E563D',
          primaryDark: '#46704A',
          primaryLight: '#BACBA9',
          grey98: '#FAFAFA',
        },
        variables: {
          notificationBgColor: 'white',
        },
      },
    },
  },
})
